import axios from "axios";

import { API_URL } from "../../.env.json";

const baseURL = API_URL;

// const baseURL = "https://senai-job.herokuapp.com/";

export const api = axios.create({
  baseURL,
});
